import { useEffect } from "react";
import Device from "../../models/Device";

import { ValueLevels } from "../../models/KnxInstanceData";

import { isUiModeProductAdmin } from "../../uiMode";

import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";

import { RuleIds } from "../../models/KnxRule";
import { nameToShortName } from "../../models/utils";
import type BaseModelReference from "../../models/BaseModelReference";
import ApplyParameterToAllDialog from "../ApplyParameterToAllDialog";
import { itx } from "../../translationItx/itx";

export default function KnxPropertyViewAdminButton(props: {
  device: Device;
  instanceId: string;
  id: string;
  label: string;
  index: number;
  defaultValue: string | undefined;
  valueList: Array<{ key: string; value: string; valueEN: string | undefined }>;
  isInCell: boolean;
  buttonContent: any;
}) {
  const { device, instanceId, id, label, index, defaultValue, buttonContent, valueList, isInCell } = props;

  const shortLabel = nameToShortName(label);

  useOnChangeWatcher(device.template?.knxProductData.currentRules);

  useEffect(() => {
    if (device.template) {
      device.template.knxProductData.setPropertyLabel(index, label, id, instanceId);
    }
  }, []);

  function handleClick(event: any) {
    const disabledContextMenuItems: any = [];

    const contextMenuItems: any = {
      title: label,
      items: [],
    };

    if (isUiModeProductAdmin()) {
      contextMenuItems.items.push({
        id: `copy`,
        label: "Copy Property Id to Clipboard", // no itx
        onClick: () => {
          let xid = instanceId ? `${id}/${instanceId}` : id;
          navigator.clipboard.writeText(`"${xid}", // ${label}`);

          state.clipboard.setDescription(label);
          state.clipboard.setData(xid, "KnxProperty");
        },
      });

      contextMenuItems.items.push({
        id: `append`,
        label: "Append Property Id to Clipboard", // no itx
        onClick: async () => {
          let xid = instanceId ? `${id}/${instanceId}` : id;

          // let s = `setProperty ("${xid}", newValue); ` + "\n";
          // s += `let value = getProperty ("${xid}"); ` + "\n";
          const clipboardLast = await navigator.clipboard.readText();

          navigator.clipboard.writeText(`${clipboardLast}\n "${xid}", // ${shortLabel}`);
        },
      });

      if (valueList.length > 0) {
        contextMenuItems.items.push({
          id: `valueList`,
          //           image: img,
          label: "Copy ValueList", // no itx
          onClick: async () => {
            let s = "";
            for (const item of valueList) {
              s += `// ${item.key} - ${item.valueEN || item.value} \n`;
            }

            navigator.clipboard.writeText(s);
          },
        });
      }

      //   contextMenuItems.items.push({
      //     id: `enable quickView`,
      //     label: "Code Quickview",
      //     onClick: () => {},
      //   });
    }

    contextMenuItems.items.push({
      id: `Apply1`,
      //           image: img,
      label: itx("KnxPropertyViewAdminButton.valueforall", "Wert für alle übernehmen"),
      onClick: async () => {
        if (device.template) {
          let allDeviceRefs = new Array<BaseModelReference>();
          allDeviceRefs = device.template.getUsages();
          for (const deviceRef of allDeviceRefs) {
            if (deviceRef.referencedObject) {
              const dev = deviceRef.referencedObject as Device;
              await dev.updateAllFromKnxMetadataImmediately();
            }
          }
          state.dialogManager.openDialog(
            <ApplyParameterToAllDialog device={device} id={id} instanceId={instanceId} valueList={valueList} />,
            true,
          );
        }
      },
    });

    contextMenuItems.items.push({
      id: `Apply1`,
      //           image: img,
      label: "Reset to default", // no itx
      onClick: () => {
        device.knxInstanceData.setValue(ValueLevels.delete, defaultValue, id, instanceId, instanceId, false);

        //
        // Reset Flag "Property is set by Estada"
        //

        const valueExt = device.knxInstanceData.getExtendedData(id, instanceId);
        if (valueExt) {
          //
          // delete Extended Data
          //
          device.knxInstanceData.setExtendedData(undefined, id, instanceId);
        }

        device.reEvalKnxMetadataNeeded = true;
        device.knxParameterViewerHasRundOnce = false;

        device.updateAllFromKnxMetadataImmediately();

        device.knxInstanceData.raiseOnChange();
        device.updateAllFromKnxMetadata();
      },
    });

    const level = device.knxInstanceData.getLevel(id, instanceId);
    if (isUiModeProductAdmin() && level == ValueLevels.calculatedByRule) {
      contextMenuItems.items.push({
        id: `Reset`,
        label: "Reset. Automatisch berechnen", // no itx
        onClick: () => {
          if (device.template) {
            device.knxInstanceData.deleteValue(id, instanceId);
          }
        },
      });
    }

    state.contextMenuManager.show1(event, contextMenuItems, disabledContextMenuItems);
  }

  const codeOnPull = device.template?.knxProductData.currentRules?.get(RuleIds.onPull, id, instanceId)?.code;
  const codeOnChange = device.template?.knxProductData.currentRules?.get(RuleIds.onChange, id, instanceId)?.code;

  // console.log(`mwe1-a ${label}: ${id} ${instanceId} ${codeOnPull}`);

  let code1 = codeOnPull ? "<b>onPull</b>\n" + codeOnPull.trim() : undefined; // no itx
  let code2 = codeOnChange ? "<b>onChange</b>\n" + codeOnChange.trim() : undefined; // no itx

  if (code1 && code2) {
    code1 += "<hr/>"; // no itx
  }

  let code: string | undefined;
  if (code1 || code2) {
    code = `${code1 ? code1 : ""}${code2 ? code2 : ""}`.replaceAll("\n", "<br/>");
  }

  if (!buttonContent) {
    return (
      <div key="A" className="knxIndicator-wrapper">
        <div
          className={"knxIndicator hidden" + (isInCell ? " small" : "")}
          style={{ backgroundColor: "transparent" }}
        ></div>
      </div>
    );
  } else {
    return (
      <div key="B" className="knxIndicator-wrapper">
        <div
          className={"knxIndicator" + (isInCell ? " small" : "")}
          style={{ display: "flex", flexDirection: "row" }}
          onClick={handleClick}
        >
          <div className="content1">{buttonContent}</div>
          <div className="content2">...</div>
        </div>
      </div>
    );
  }
}
